<template>
  <b-modal
    id="modal-global-filter"
    :title="$t('Periods & Filters')"
    :ok-title="$t('OK')"
    :cancel-title="$t('Cancel')"
    cancel-variant="outline-secondary"
    size="lg"
    :no-close-on-backdrop="true"
    @ok="handleOk"
  >
    <form-global-filter
      ref="global_filter_form"
      @filterApplied="filterApplied"
    />
  </b-modal>
</template>

<script>
import {
  BModal, VBModal,
} from 'bootstrap-vue'

import FormGlobalFilter from './forms/FormGlobalFilter.vue'

export default {
  components: {
    BModal,
    FormGlobalFilter,
  },
  directives: {
    'b-modal': VBModal,
  },
  methods: {
    filterApplied(args) {
      this.$emit('filterApplied', args)
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.$refs.global_filter_form.validationForm()
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.vs__dropdown-toggle {
  border:1px solid #d8d6de !important
}
</style>
